// store/slices/authSlice.js

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  inactive: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setInactive: (state, action) => {
      state.inactive = action.payload;
    },
    clearInactive: (state) => {
      state.inactive = false;
    },
  },
});

export const { setInactive, clearInactive } = authSlice.actions;
export default authSlice.reducer;